type QueryTypes = 'direct' | 'dashboard' | string;

export const wnwVariantMapper = (variant?: QueryTypes) => {
    if (!variant) return;

    switch (variant) {
        case 'direct':
            return 'wnw_direct';
        case 'dashboard':
            return 'wnw_dashboard';
        default:
            return undefined;
    }
};
